import { QueryClient, type QueryClientConfig } from '@tanstack/react-query';

// React Query Configuration
export const queryClientConfig: QueryClientConfig = {
  defaultOptions: {
    queries: {
      // No staleTime — data is always considered stale, so refetchOnWindowFocus /
      // refetchOnMount / refetchOnReconnect actually fire (focus refetch was being
      // suppressed while data was still "fresh").
      // Cache garbage collection after 5 minutes
      gcTime: 1000 * 60 * 5,
      // Retry failed requests once (2 total attempts: 1 initial + 1 retry)
      retry: 1,
      // Exponential backoff for retries
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      // Refetch on window focus for fresh data
      refetchOnWindowFocus: true,
      refetchOnMount: 'always',
      // Don't refetch on reconnect
      refetchOnReconnect: true,
    },
    mutations: {
      // Don't retry mutations by default
      retry: false,
    },
  },
};

// Create and export query client
export const queryClient = new QueryClient(queryClientConfig);
